import { graphql } from 'react-relay';
import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	preloadPageStatusQueryDataQuery$data,
	preloadPageStatusQueryDataQuery$variables,
} from './__generated__/preloadPageStatusQueryDataQuery.graphql.ts';

const PreloadPageStatusQuery = graphql`
	query preloadPageStatusQueryDataQuery($contentId: ID!) {
		content(id: $contentId, status: ["archived", "current"]) {
			nodes {
				id
				status
			}
		}
	}
`;

export function preloadPageStatusQuery(contentId: string): Promise<{
	data: preloadPageStatusQueryDataQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<preloadPageStatusQueryDataQuery$data, preloadPageStatusQueryDataQuery$variables>({
		query: PreloadPageStatusQuery,
		variables: {
			contentId,
		},
	});
}
